import { useRef, useState } from "react";
import { CallProvider } from "@/call/CallProvider";
import { CallView } from "@/components/CallView";
import { Every } from "@/components/Every";
import { Faq } from "@/components/Faq";
import { FloatingCall } from "@/components/FloatingCall";
import { Footer } from "@/components/Footer";
import { InkDefs } from "@/components/ink";
import { Intro } from "@/components/Intro";
import { Logos } from "@/components/Logos";
import { Nav } from "@/components/Nav";
import { PilotDialog } from "@/components/PilotDialog";
import { Reel } from "@/components/Reel";
import { StatesBar } from "@/components/StatesBar";
import { useBoil } from "@/lib/use-boil";

export function Landing() {
  useBoil();
  return (
    <CallProvider>
      <Page />
    </CallProvider>
  );
}

function Page() {
  const live = useRef<HTMLElement>(null);
  const [opened, setOpened] = useState(false);
  const states = new URLSearchParams(window.location.search).has("states");

  return (
    <>
      <InkDefs />
      <Nav />

      <div className="lp">
        <Intro />

        <div className="col">
          <Logos />
        </div>

        <Every />

        {/* The film runs past the column, in a card of its own. */}
        <div className="reel">
          <Reel />
        </div>

        <div className="col trial">
          <section className="live" id="live" ref={live}>
            <div className="l">
              <h2>Talk to our AI receptionist</h2>
              <p className="sub">
                Ring it from here and ask what a customer would.
              </p>
            </div>
            <div className="r">
              <CallView view="page" />
            </div>
          </section>
        </div>

        <div className="col">
          <Faq />
        </div>

        <Footer />
      </div>

      <FloatingCall callRef={live} opened={opened} setOpened={setOpened} />
      {states && <StatesBar opened={opened} setOpened={setOpened} />}
      <PilotDialog />
    </>
  );
}
